import ViewPreviousHistoryModal from './ViewPreviousHistoryModal'
import ANTDButton from '../../../shared/antd/ANTDButton'
import { ANTDDateRange } from '../../../shared/antd/ANTDDatePicker'
import ANTDSelect from '../../../shared/antd/ANTDSelect'
import Label from '../../../shared/Label'
import { SAVE_FORMAT } from '../../../utils/dayjs'
import tallyReports from '../container/tallyReports.container'

const TallyReports = () => {
  const {
    t,
    sourceType,
    dateRanges,
    reportsTypeList,
    fiscalYearOptions,
    viewPreviousHistory,
    onGenerateReport,
    onDateRangeChange,
    onFiscalYearChange,
    onViewHistoryModelClose,
  } = tallyReports()

  return (
    <>
      {reportsTypeList.map(
        ({
          title,
          sheetType,
          dateLabel,
          showSource,
          generateReportLabel,
          onSourceChange,
          onViewClick,
        }) => (
          <div
            key={title}
            className="d-flex flex-wrap space-between report-filter-only"
          >
            <h2 className="mt-5">{t(title)}</h2>
            <div className="d-flex justify-content-end">
              <div>
                {showSource && (
                  <div>
                    <Label text={t('job_Source')} />
                    <ANTDSelect
                      className="w-100 mt-5"
                      {...{
                        width: '100%',
                        value: sourceType,
                        options: [
                          {
                            label: 'Aggregation Center',
                            value: 'STOCK_ITEMS_COLLECTION_CENTER_SHEET',
                          },
                          {
                            label:
                              'Others (Dealer, Direct Individual, Test Vehicle)',
                            value: 'STOCK_ITEMS_DIRECT_DEALER_INDIVIDUAL_SHEET',
                          },
                        ],
                        onChange: onSourceChange,
                      }}
                    />
                  </div>
                )}
                <div>
                  <Label text={t('txt_FiscalYear')} />
                  <ANTDSelect
                    className="w-100 mt-5"
                    {...{
                      width: '100%',
                      options: fiscalYearOptions,
                      value: dateRanges[sheetType].fiscalYear,
                      onChange: value => onFiscalYearChange(sheetType, value),
                    }}
                  />
                </div>
                <div className="mt-10">
                  <Label text={t(dateLabel)} />
                  <ANTDDateRange
                    {...{
                      format: SAVE_FORMAT,
                      value: dateRanges[sheetType].range,
                      onChange: value => onDateRangeChange(sheetType, value),
                    }}
                  />
                  <ANTDButton
                    type="primary"
                    className="ml-10 mt-10"
                    onClick={() => onGenerateReport({ sheetType })}
                  >
                    {t(generateReportLabel)}
                  </ANTDButton>
                  <ANTDButton
                    type="primary"
                    className="ml-10 mt-10"
                    onClick={onViewClick}
                  >
                    {t('btn_ViewPreviousHistory')}
                  </ANTDButton>
                </div>
              </div>
            </div>
          </div>
        ),
      )}

      <ViewPreviousHistoryModal
        open={viewPreviousHistory.open}
        onClose={onViewHistoryModelClose}
        payload={{
          sheetType: viewPreviousHistory.sheetType,
        }}
      />
    </>
  )
}

export default TallyReports
